// extracted by mini-css-extract-plugin
export default {"root":"NoticeLayout_root__0-Huu","head":"NoticeLayout_head__ZLFBY"};